import { IEvent } from "~app/common/services/cqs/event.service";

export class RapportUtskriftCreatedEventMessage implements IEvent {
    $type = RapportUtskriftCreatedEventMessage.TYPE;
    kontraktId: number;
    dokumenttyper: string[];
    success: boolean;
    static readonly TYPE = "RapportutskriftCreatedEventMessage";
}
